import { render, staticRenderFns } from "./FaxTable.vue?vue&type=template&id=62ec4762&scoped=true&"
import script from "./FaxTable.vue?vue&type=script&lang=js&"
export * from "./FaxTable.vue?vue&type=script&lang=js&"
import style0 from "./FaxTable.vue?vue&type=style&index=0&id=62ec4762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ec4762",
  null
  
)

export default component.exports